const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

async function request(path, options = {}) {
  const res = await fetch(`${BASE}${path}`, {
    headers: { "Content-Type": "application/json" },
    ...options,
  });
  if (!res.ok) {
    const detail = await res.json().catch(() => ({}));
    throw new Error(detail.detail || `Request failed (${res.status})`);
  }
  return res.json();
}

export function fetchResources(params = {}) {
  const q = new URLSearchParams(params).toString();
  return request(`/resources${q ? `?${q}` : ""}`);
}

export function fetchResource(slug) {
  return request(`/resources/${slug}`);
}

export function adminListResources() {
  return request("/admin/resources");
}

export function adminCreateResource(data) {
  return request("/admin/resources", { method: "POST", body: JSON.stringify(data) });
}

export function adminUpdateResource(id, data) {
  return request(`/admin/resources/${id}`, { method: "PUT", body: JSON.stringify(data) });
}

export function adminDeleteResource(id) {
  return request(`/admin/resources/${id}`, { method: "DELETE" });
}
